import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectDropdown from "../components-react/SelectDropdown";
// import DateRanger from "../components-react/DateRanger";
// import moment from "moment";
// import { format, addDays } from "date-fns";
// import { Button } from "react-bootstrap";
import { fetchGymData } from "../../data/APIs";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import {
  setSelectedGym,
  //   setStartAndEndDate,
  setSelectedMonth,
  setSelectedYear,
} from "../../redux/reducers/filtersSlice";
import { allMonths } from "../../exports/ProfitShareData";
import { selectAuth } from "../auth/auth.selector";
// import { decryptedText } from "../../data/DecrytedDatas";

function GymAndDates() {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const gymData = useSelector(selectGymData);
  const selectedGym = useSelector((state) => state.filters.selectedGym);
  const selectedMonth = useSelector((state) => state.filters.selectedMonth);
  const selectedYear = useSelector((state) => state.filters.selectedYear);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  function generateYears() {
    const startYear = 2023;
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push({ label: year.toString(), value: year });
    }
    return years;
  }
  const allYears = generateYears();

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, [dispatch]);

  useEffect(() => {
    if (
      decryptedText?.account_type === "receptionist" ||
      decryptedText?.account_type === "gym"
    ) {
      dispatch(
        setSelectedGym({
          label: "",
          value: decryptedText?.gym_id || decryptedText?.uid,
        })
      );
    }
  }, [decryptedText]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="mainContainer">
      <div className="innerContainer">
        <div className="globalGymANdDatesFilterContainer">
          <div
            className="innerGlobalGymANdDatesFilterContainer"
            style={{ margin: "0" }}
          >
            {decryptedText?.account_type === "admin" && (
              <div className="commonWrapper">
                <SelectDropdown
                  options={gymData}
                  selectedOption={selectedGym}
                  setSelectedOption={
                    (selectedValue) => dispatch(setSelectedGym(selectedValue))
                    // setSelectedGym(selectedValue)
                  }
                  name="Gym"
                />
              </div>
            )}

            <>
              {/* {selectedTab === "settlement" && (
              <div className="commonWrapper marginleft">
                {startAndEndDate.selectedDates ? (
                  <span
                    className="selectDateRageButton selectedDatesShow"
                    onClick={() => setDateRangerOpen(true)}
                  >
                    {startAndEndDate.selectedDates}
                  </span>
                ) : (
                  <button
                    className="selectDateRageButton"
                    onClick={() => setDateRangerOpen(true)}
                  >
                    select date range
                  </button>
                )}
              </div>
            )} */}
            </>

            {/* {selectedTab === "cto" && ( */}
            <div className="commonWrapper marginleft">
              <SelectDropdown
                options={allMonths}
                selectedOption={selectedMonth}
                setSelectedOption={(selectedValue) =>
                  dispatch(setSelectedMonth(selectedValue))
                }
                name="Month"
              />
            </div>
            {/* )} */}

            <div className="commonWrapper marginleft">
              <SelectDropdown
                options={allYears}
                selectedOption={selectedYear}
                setSelectedOption={(selectedValue) =>
                  dispatch(setSelectedYear(selectedValue))
                }
                name="Year"
              />
            </div>
          </div>

          <>
            {/* {dateRangerOpen &&
                        <div className="openedDateRanger">
                            <div className="closeAndClearDateRangerButtons">
                                <Button
                                    variant="primary"
                                    onClick={() => setDateRangerOpen(false)}
                                >
                                    Close
                                </Button>
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        setDateRangerOpen(false);
                                        setRangeState(initialRangeState);
                                        dispatch(setStartAndEndDate({
                                            startDate: null,
                                            endDate: null,
                                            selectedDates: null,
                                        }));
                                        dispatch(setSelectedGym(null))
                                    }}
                                >
                                    Clear
                                </Button>
                            </div>
                            <DateRanger
                                handleDateRangeChange={handleDateRangeChange}
                                rangeState={rangeState}
                            />
                        </div>
                    } */}
          </>
        </div>
      </div>
    </div>
  );
}

export default GymAndDates;
